export const getMedian = (arrayOfNumbers) => {
  const cloned = [...arrayOfNumbers];
  cloned.sort((a, b) => a - b);
  return cloned[Math.floor(cloned.length / 2)];
};

export const generateRandomInteger = (min, max) => {
  return parseInt(Math.random() * (max - min), 10) + min;
};
